module.exports = __webpack_public_path__ + "static/profile-pic-fb823dbb475eaac34cc8a8ffed29a9f4.png";